module.exports = __webpack_public_path__ + "images/a1aff7a925eda5be03cfebdd835364c3.svg";